var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var StandoffSpacerGeneratorInteractionModel = require('./standoffSpacerGeneratorInteractionModel.js');

var FemaleStandoffSpacerGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;
    StandoffSpacerGeneratorInteractionModel.apply(this, arguments);

    this.hasThread = this.shadow("hasThread",
        function() {
            return self.data.hasThread();
        },
        function(value) {
            return self.data.hasThread(value);
        },
        [
            self.data.hasThread
        ]
    );

    this.hasPartialThread = this.shadow("hasPartialThread",
        function() {
            return self.data.hasPartialThread();
        },
        function(value) {
            return self.data.hasPartialThread(value);
        },
        [
            self.data.hasPartialThread
        ]
    );

    this.threadType = this.shadow("threadType",
        function() {
            return self.data.threadType();
        },
        function(value) {
            return self.data.threadType(value);
        },
        [
            self.data.threadType
        ]
    );

    this.threadSize = this.shadow("threadSize",
        function() {
            return self.data.threadSize();
        },
        function(value) {
            return self.data.threadSize(value);
        },
        [
            self.data.threadSize
        ]
    );

    this.threadDesignation = this.shadow("threadDesignation",
        function() {
            return self.data.threadDesignation();
        },
        function(value) {
            return self.data.threadDesignation(value);
        },
        [
            self.data.threadDesignation
        ]
    );

    this.threadDepth = this.shadow("threadDepth",
        function() {
            return self.data.threadDepth() / self.getUnitFactor();
        },
        function(value) {
            return self.data.threadDepth(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.threadDepth, self.userSettingsModel.distanceUnit
        ]
    );

    this.threadSizeList = this.value("threadSizeList", true);
    this.threadDesignationList = this.value("threadDesignationList", true);
    this.initializeThreadInfo(this.data.threadType, this.data.threadSize, this.data.threadDesignation, this.threadSizeList, this.threadDesignationList);
};

lib_core.inherit(FemaleStandoffSpacerGeneratorInteractionModel, StandoffSpacerGeneratorInteractionModel);
StandoffSpacerGeneratorInteractionModel.$class = 'FemaleStandoffSpacerGeneratorInteractionModel';
module.exports = FemaleStandoffSpacerGeneratorInteractionModel;

FemaleStandoffSpacerGeneratorInteractionModel.prototype.getInspectorElementForThreading = function() {
    var hasThread = PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('threaded', 'Threaded'), this.hasThread);
    var hasPartialThread = PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('partialThread', 'Partial Thread'), this.hasPartialThread, this.hasThread);
    var threadDepth = PackageGeneratorInspectorConfig.getValueFixedUnit('L', this.LCLZ('threadDepth', 'Thread Depth'), this.threadDepth, this.userSettingsModel.distanceUnit, this.hasPartialThread);
    //var threadType = PackageGeneratorInspectorConfig.getSelectbox('Thread Type', this.threadType, this.getThreadTypes(), this.hasThread);
    var threadSize = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('threadSize', 'Thread Size'), this.threadSize, this.threadSizeList, this.hasThread);
    var threadDesignation = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('threadDesignation', 'Thread Designation'), this.threadDesignation, this.threadDesignationList, this.hasThread);
    
    return [hasThread, hasPartialThread, threadDepth, /*threadType, */threadSize, threadDesignation];
};

FemaleStandoffSpacerGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = StandoffSpacerGeneratorInteractionModel.prototype.getInspectorElements.call(this).input_elements;

    imElements.unshift(this.getInspectorElementForLabel(this.LCLZ('femaleStandoffNote', '* Mounting hole pad is optional and can be generated by entering values for dimensions shown in the left image. Hole diameter (b) is used for mounting hole generation and for spacer mechanical model without internal threading.'))[0]);
    imElements = imElements.concat(this.getInspectorElementForThreading());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
